import { render, staticRenderFns } from "./InputSugestaoCliente.vue?vue&type=template&id=76b1982e&"
import script from "./InputSugestaoCliente.vue?vue&type=script&lang=js&"
export * from "./InputSugestaoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports